module.exports = __webpack_public_path__ + "img/高通锐化50.36469fe7.png";